import { useEffect, useState } from 'react'

import { useMutation } from '@redwoodjs/web'

import {
  ItListAnalyticsProps,
  useAnalytics,
} from 'src/lib/hooks/analytics/useAnalytics'
import { useEnsureAuthenticated } from 'src/lib/hooks/auth/useEnsureAuthenticated'

const TOGGLE_LIKE_MUTATION = gql`
  mutation ToggleLikeItListMutation($id: Int!) {
    toggleLikeItList(id: $id)
  }
`

type ToggleLikeItListResponse = {
  toggleLikeItList: boolean
}

export default function useLikeButton(
  liked: boolean,
  itListId: number,
  trackingData: ItListAnalyticsProps
) {
  const [toggleLike, response] =
    useMutation<ToggleLikeItListResponse>(TOGGLE_LIKE_MUTATION)
  const { track } = useAnalytics()
  const [isLiked, setIsLiked] = useState(liked)
  const toggleLikeIfAuthenticated = useEnsureAuthenticated({
    action: {
      name: 'like',
      isDone: liked,
      callback: async () => {
        toggle()
      },
    },
  })
  const toggle = () => {
    track({
      eventName: isLiked ? 'ItList Un-Wishlisted' : 'ItList Wishlisted',
      props: trackingData,
    })
    setIsLiked(!isLiked)
    toggleLike({ variables: { id: itListId } })
  }

  const clickHandler: React.MouseEventHandler<HTMLButtonElement> = (ev) => {
    ev.stopPropagation()
    ev.preventDefault()

    track({
      eventName: 'ItList Wishlist Clicked',
      props: trackingData,
    })
    toggleLikeIfAuthenticated()
  }

  useEffect(
    () => response?.data && setIsLiked(response.data.toggleLikeItList),
    [response]
  )

  return { clickHandler, isLiked }
}
